import { errorLogger } from '@ajaibid/utils';
import fetcher from '@helpers/fetcher';

import { PANIC_KEYS } from './constants';

function getUrl(key) {
  return `v1/stock/odt/admin/system-param/${key}`;
}

/**
 * @param {string[]} urls
 * @returns
 */
function callbackFetch(urls) {
  return async () => {
    try {
      // Map urls object into array, then store to a const (to preserve element position)
      const _keys = Object.keys(urls);

      // Call the URLs asynchronously
      /** @type {import('./typedefs').Response[]} */
      const res = await Promise.all(_keys.map((_k) => fetcher.get(urls[_k])));

      // Map each response to each keys, for easier access
      /** @type {Record<string, import('./typedefs').StockDtSystemParam>} */
      const ret = _keys.reduce((obj, _k, i) => ({ ...obj, [_k]: res[i].data.result }), {});
      return ret;
    } catch (err) {
      errorLogger('ERROR_API', err.message);
      throw err;
    }
  };
}

export default function fetch() {
  // const urls = Object.values(PANIC_KEYS).map((v) => getUrl(v));

  const urls = Object.keys(PANIC_KEYS).reduce(
    (obj, key) => ({ ...obj, [key]: getUrl(PANIC_KEYS[key]) }),
    {}
  );

  return {
    cb: callbackFetch(urls),
    key: [urls],
  };
}
